export const automationRouteNames = {
  default: 'automation-v2',
  newWorkflows: 'newWorkflows-v2',
  workflows: 'workflows-v2',
  contentAI: 'content-ai-v2',
  campaigns: 'campaigns-v2',
  campaignEdit: 'campaign_edit-v2',
  campaignDetail: 'campaign_detail-v2',
  campaignAccountsList: 'campaign_accounts_list-v2',
  campaignActivity: 'campaign_activity-v2',
  bulkRequests: 'bulk_requests-v2',
  triggers:'triggers-v2',
  triggerDetail:'triggers_detail-v2',
}
